export const APP_NAME = 'Dialworks'
export const APP_PREFIX_PATH = '/app'
export const AUTH_PREFIX_PATH = '/auth'
export const ADMIN_PREFIX_PATH = '/admin' // can only accesible to admin

export const ONBOARD_PREFIX_PATH = '/onboarding'
export const INVOICE_PREFIX_PATH = '/invoices'
export const WELCOME_PREFIX_PATH = '/welcome'
